<template>
  <div class="column-wrap">
    <div class="nav-wrap">
      <div class="flex">
        <i class="iconfont icon-home1"></i>
        <router-link class="link" to="/">首页</router-link>
        <i class="el-icon-arrow-right"></i>
        <router-link class="link" :to="$route.path" replace
          ><span>专题专栏</span></router-link
        >
      </div>
    </div>
    <div class="column-image-box flex">
      <div class="image-box" v-for="(item, index) in list" :key="index">
        <a :href="item.href" target="_blank">
          <img :src="item.image" :alt="item.title" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [
        {
          href: 'http://xyd.taian.cn/user/register',
          title: '肥城站',
          image: require('@/static/images/celoan.jpg'),
        },
        // {
        // 	href: 'https://www.celoan.cn/?city=Taian',
        // 	title: '',
        // 	image: require('@/static/images/celoan.jpg')
        // },
        // {
        // 	href: 'https://www.celoan.cn/?city=Taian',
        // 	title: '',
        // 	image: require('@/static/images/celoan.jpg')
        // }
      ],
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.column-wrap {
  background: #ffffff;
  .column-image-box {
    width: 1280px;
    background: #fff;
    margin: 20px auto 0;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px 20px 0;

    .image-box {
      width: 49%;
      height: 160px;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
